module.exports = __webpack_public_path__ + "static/media/calendar-off.6c1e42d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/calendar-off.svg
// module id = 772
// module chunks = 0